import React from 'react';

import Grid from '../grid/Grid';
import GridElement from '../grid/GridElement';
import CalendarGrid from './CalendarGrid';
import timeUnits from './timeUnits';

export const TimeTable = props => {

    const { courses, options, selectedPeriod } = props;
    
    return timeUnits.map((unit,idx) => {
        return (
            <Grid key={idx}>
                <GridElement
                    colStart={1}
                    colEnd={6}
                    rowStart={1}
                >
                    <CalendarGrid 
                        unit={unit} 
                        index={idx} 
                        courses={courses} 
                        options={options}
                        selectedPeriod={selectedPeriod}
                        handleCollision={props.handleCollision}
                    />
                </GridElement>
            </Grid>
        )
    })
}

export default TimeTable;






// WEBPACK FOOTER //
// ./src/partials/modules/TimePlanNew/timetable/TimeTable.js